import React, { useState } from "react";
import api from "../../lib/api";

export default function TrendsModal({ open, onClose, onPickTopic }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [topics, setTopics] = useState([]);
  const [raw, setRaw] = useState(null);
  const language = "en";
  const geo = "US";

  if (!open) return null;

  const fetchTrends = async () => {
    setBusy(true);
    setError(null);
    try {
      const { data } = await api.post("/api/admin/ai/trends", { language, geo });
      setTopics(data.topics || []);
      setRaw(data.raw || null);
    } catch (e) {
      setError(e?.response?.data?.error || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal__head">
          <div>
            <span className="eyebrow">Discover</span>
            <h2 style={{ marginTop: 6, fontSize: 24 }}>Trending software topics</h2>
            <p style={{ color: "var(--muted)", fontSize: 14, marginTop: 4 }}>
              Pulled live from Hacker News, GitHub, Dev.to and Lobsters — filtered for the Node.js,
              React, Shopify and full-stack ecosystem, then clustered by AI into post-ready topics.
            </p>
          </div>
          <button type="button" className="modal__close" onClick={onClose} aria-label="Close">×</button>
        </div>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 20 }}>
          <button type="button" className="btn" onClick={fetchTrends} disabled={busy}>
            {busy ? "Fetching…" : topics.length ? "Refresh" : "Fetch trends"}
          </button>
        </div>

        {error && <p style={{ color: "var(--danger)" }}>{error}</p>}

        {!busy && topics.length === 0 && !error && (
          <p style={{ color: "var(--muted)" }}>
            Click <em>Fetch trends</em> to pull Node.js / React / Shopify topics from HN, GitHub,
            Dev.to and Lobsters.
          </p>
        )}

        {topics.map((t, i) => (
          <article key={i} className="topic-card">
            <h4>{t.title}</h4>
            <p>{t.angle}</p>
            <div className="meta">
              {(t.tags || []).map((tg, j) => <span key={j}>#{tg}</span>)}
            </div>
            <div className="actions">
              <button
                type="button"
                className="btn"
                onClick={() => { onPickTopic(t); onClose(); }}
              >
                Use this topic
              </button>
              <button
                type="button"
                className="chip"
                style={{ cursor: "pointer" }}
                onClick={() => navigator.clipboard?.writeText(t.prompt)}
              >
                Copy prompt
              </button>
            </div>
          </article>
        ))}

        {raw && (
          <details style={{ marginTop: 20, color: "var(--muted)" }}>
            <summary style={{ cursor: "pointer", fontFamily: "var(--font-display)", fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase" }}>
              Raw sources
            </summary>
            <div style={{ marginTop: 12, display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16, fontSize: 13 }}>
              {[
                ["Hacker News", raw.hn],
                ["GitHub", raw.gh],
                ["Dev.to", raw.dev],
                ["Lobsters", raw.lo],
              ].map(([name, list]) => (
                <div key={name}>
                  <strong style={{ color: "var(--text)" }}>{name}</strong>
                  <ul style={{ paddingLeft: 16, marginTop: 6 }}>
                    {(list || []).slice(0, 6).map((it, idx) => (
                      <li key={idx} style={{ marginBottom: 4 }}>
                        <a href={it.url} target="_blank" rel="noreferrer noopener">{it.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </details>
        )}
      </div>
    </div>
  );
}
